export enum WithLenderPaymentMethod {
  CREDIT_LINE = 'credit_line',
  CONSUMER_LOAN_INSTALMENTS = 'consumer_loan_instalments',
  CONSUMER_LOAN_SPLIT_PAY = 'consumer_loan_split_pay',
  BNPL_INSTALMENTS = 'bnpl_instalments',
  BNPL_SPLIT_PAY = 'bnpl_split_pay',
  AUTO_LOAN = 'auto_loan',
  B2B_LOAN = 'b2b_loan',
  CARD_ONBOARDING = 'card_onboarding',
  //   SUBSCRIPTION = 'subscription',
}
export type WithLenderPaymentMethodType = WithLenderPaymentMethod;
